import React from 'react';
import Layout from '../../components/templates/Layout';
import MyClasses from './MyClasses';

const Dashboard = () => {
  return (
    <Layout backgroundImage=''>
      <MyClasses />
    </Layout>
  );
};

export default Dashboard;
